import React from 'react';
import PropTypes from 'prop-types';
import css from './UpcomingLocation.css';
import Icon from 'SF/MaterialIcon';
import { getWord } from "utils/tenant";

export default class UpcomingCourse extends React.Component {

  get title() {
    return `${getWord("course", false)} Context`;
  }

  render() {
    return (
      <div className={css['location-container']}>
        <div><Icon aria-label={this.title} title={this.title} icon="school" /></div>
        <div><div className="name">{this.props.name}</div></div>
      </div>
    );
  }
}

UpcomingCourse.propTypes = {
  name: PropTypes.string.isRequired
};
